import { Component, OnDestroy, OnInit, signal } from '@angular/core'
import { DateTime } from 'luxon'

@Component({
	selector: 'app-clock',
	template: ` {{ currentTime() }} `,
	styleUrl: './clock.component.scss',
})
export class ClockComponent implements OnInit, OnDestroy {
	readonly currentTime = signal<string>('')
	readonly intervalId = signal<NodeJS.Timeout | null>(null)

	ngOnInit(): void {
		this.intervalId.set(setInterval(() => this.#updateTime(), 1000))
	}

	ngOnDestroy(): void {
		clearInterval(this.intervalId())
	}

	#updateTime(): void {
		const now = DateTime.local()

		this.currentTime.set(now.toFormat('h:mm:ss a'))
	}
}
